/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, interval, of } from 'rxjs';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import {
    fetchCashboxStatisticsAction,
    fetchCashboxStatisticsErrorAction,
    fetchCashboxStatisticsSuccessAction,
    StatisticsActions,
    StatisticsActionType,
} from '../actions/statisticsActions';
import { statisticsClient } from '../api/statistics/statisticsClient';

const STATISTICS_POLLING_INTERVAL = 60000;

export const fetchCashboxStatisticsEpic: Epic<StatisticsActions> = (action$) => {
    return action$.pipe(
        ofType(StatisticsActionType.OPEN_STATISTICS_PAGE, StatisticsActionType.FETCH_CASHBOX_STATISTICS),
        switchMap(() => {
            return from(statisticsClient.getCashBoxesStatistics()).pipe(
                map((data) => {
                    return fetchCashboxStatisticsSuccessAction(data);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchCashboxStatisticsErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.cashBoxesStatsNotFound')),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(StatisticsActionType.EXIT_STATISTICS_PAGE)),
            );
        }),
    );
};

export const fetchCashboxStatisticsByIntervalEpic: Epic<StatisticsActions> = (action$) => {
    return action$.pipe(
        ofType(StatisticsActionType.OPEN_STATISTICS_PAGE),
        switchMap(() => {
            return interval(STATISTICS_POLLING_INTERVAL).pipe(
                map(() => {
                    return fetchCashboxStatisticsAction();
                }),
                takeUntil(action$.ofType(StatisticsActionType.EXIT_STATISTICS_PAGE)),
            );
        }),
    );
};
